import useCompilerPdfLogic from 'components/v2/compiler/useCompilerPdfLogic';
import React from 'react';
import AuthService from 'services/AuthService';
import EPDCertificatePage from './EPDRegistrationCertificatePage';
import { useEpdRegistrationCertificateData } from 'services/api/queries';

const EpdRegistrationCertificatePreviewAuth: React.FunctionComponent = () => {
  const { epdVersionId } = useCompilerPdfLogic();
  const epdCertificateData = useEpdRegistrationCertificateData(epdVersionId).data;

  if (!AuthService.isLoggedin()) {
    return null;
  }

  if (!epdCertificateData) {
    return <div>Loading data...</div>;
  }


  return (
    <EPDCertificatePage epdCertificateData={epdCertificateData}/>
  );
};

export default EpdRegistrationCertificatePreviewAuth;
